import { useState } from 'react';

import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import { excelDownLoad } from '../../../../../lib/common';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { CS_INQUIRY_LIST_SORT_OPTION_MODEL } from '../../../../../store/modules/cs/inquiry/models';
import { ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/account/user/models';
import { useAccountUserCsInquiryDetailQuery, useAccountUserDetailCsInquiryListExcelDownloadMutate } from './query';
import { getTablePages } from '../../../../../lib/utils/tableUtils';

export const useAccountUserCsInquiryDetail = ({ userId, isActive }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [sortOption, setSortOption] = useState(CS_INQUIRY_LIST_SORT_OPTION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_CS_INQUIRY_HISTORY_LIST_FILTER_OPTION_MODEL);
  const { data } = useAccountUserCsInquiryDetailQuery({
    userId,
    pagination,
    sortOption,
    filterOption,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_CS_INQUIRY_DETAIL_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        list: result.data.csInquiryList.list,
        totalCnt: result.data.csInquiryList.totalCnt,
      }),
    },
  });

  const { mutateAsync } = useAccountUserDetailCsInquiryListExcelDownloadMutate();

  const downloadDetailCsInquiryListExcel = async () => {
    try {
      const result = await mutateAsync({
        userId,
        csInquiryHistory: {
          filterOption,
          sortOption,
          pagination,
        },
      });

      toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad('유저 상세 문의 리스트', result.data.csInquiryListExcelSheet);
    } catch (error) {
      toastMsg.error(error.message);
    }
  };

  const getList = ({ filterOption, pagination, sortOption }) => {
    filterOption && setFilterOption(filterOption);
    pagination && setPagination(pagination);
    sortOption && setSortOption(sortOption);
  };

  return {
    csInquiryList: data,
    getList,
    downloadDetailCsInquiryListExcel,
    pagination: { ...pagination, pages: getTablePages(data.totalCnt, pagination.pageSize) },
    sortOption,
    filterOption,
  };
};
